import React from 'react';
import { BsChatRightTextFill } from 'react-icons/bs';
import StarRating from '../../../components/UI/StarRating'; // Adjust path if needed
import styles from '../FeedbackPage.module.css';// Adjust if your styles file differs

const QuestionSection3 = ({
  activeSection,
  q3Rating,
  handleRatingChange,
  moveToPreviousSection,
  moveToNextSection,
  isLoading
}) => {
  return (
    <div 
    id="section-3" 
    className={`${styles.questionSection} ${activeSection === 3 ? styles.active : ''}`}
>
    <div className={styles.questionIcon}>
    <BsChatRightTextFill />
    </div>
    <label className={styles.questionLabel}>
        3. How would you rate the infographics generated? <span className={styles.required}>*</span>
    </label>
    <div className={styles.ratingContainer}>
        <StarRating
            rating={q3Rating}
            onRate={(rate) => handleRatingChange(3, rate)}
            disabled={isLoading}
            size={32}
        />
        {q3Rating > 0 && (
            <div className={styles.ratingText}>
                {q3Rating === 1 && 'Poor'}
                {q3Rating === 2 && 'Fair'}
                {q3Rating === 3 && 'Good'}
                {q3Rating === 4 && 'Very Good'}
                {q3Rating === 5 && 'Excellent'}
            </div>
        )}
    </div>
    <div className={styles.navigationButtons}>
        <button 
            type="button" 
            className={`${styles.btn} ${styles.btnSecondary}`} 
            onClick={moveToPreviousSection}
        >
            Previous
        </button>
        <button 
            type="button" 
            className={`${styles.btn} ${styles.btnPrimary}`} 
            disabled={q3Rating === 0}
            onClick={moveToNextSection}
        >
            Next
        </button>
    </div>
</div>
  );
};

export default QuestionSection3;
